import { Flex } from "@/common/styles";
import { CONSTANT } from "@/util/ant_var";
import { Col, Container, Row } from "react-bootstrap";
import styled, { css } from "styled-components";
import { FlagContainer } from "../InmateFlag/styles";

export const InmateHeaderContainer = styled(Flex)`
  align-items: stretch;
  justify-content: space-between;
  padding: 5px 15px;
  background-color: #045a7c;

  .left {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex: 1;

    & img {
      width: 25px;
    }
  }

  .right {
  }
`;

export const InmateName = styled.div`
  font-size: 18px;
  font-weight: 500;
  color: white;
  text-transform: uppercase;
  margin-left: 15px;
`;

export const BookingFlagsContainer = styled(Flex)`
  align-items: stretch;
`;

export const InmatePreviewContainer = styled(Flex)`
  min-height: 180px;
  width: 100%;
  background: #0b3151;
  align-items: stretch;
  & > .avatar-container {
    position: relative;
    > img {
      width: auto;
      max-width: 190px;
      min-width: 190px;
    }
  }

  & > .avatar-container {
    position: relative;
    > .avatar {
      width: auto;
      max-width: 190px;
      min-width: 190px;
    }
  }

  .preview-actions {
    position: relative;
    background-color: #134062;
    flex-basis: 60px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .prf-actions {
    }

    button {
      width: 40px;
      height: 40px;
      margin: 5px auto;
    }

    .action-pagination {
      color: white;
      text-align: center;
      margin: 10px auto;

      .arrow {
        cursor: pointer;
        margin: 5px 3px;
        transition: all 0.3s ease-in-out;
      }

      .arrow.disabled {
        opacity: 0.3;
        pointer-events: none;
      }

      .arrow:hover {
        opacity: 0.8;
      }
    }
  }
`;

export const InmateDetails = styled(Container)`
  padding-bottom: 10px;
`;

export const InmateInformationMixinCss = css`
  --bs-gutter-y: 0.5rem;
  font-weight: 500;
  text-transform: uppercase;
  display: flex;
  gap: 10px;
  font-size: 12px;
  /* flex: 1; */

  &:first-child {
    /* padding-left: unset; */
  }

  &:last-child {
    /* padding-right: unset; */
  }

  .key,
  .value {
    color: white;
    text-align: center;
    height: 40px;
    text-transform: uppercase;
    display: flex;
    align-items: center;
  }

  .key {
    flex-shrink: 0;
    justify-content: center;
    font-weight: 500;
    color: var(--text-blue);

    & img {
      height: 20px;
      margin-right: 1em;
    }
  }

  .value {
    color: white;
    flex: 1;
    padding: 0 10px;
    background: #114a6b;
    /*justify-content: center;*/
    /*box-shadow: inset 0 1px 0 0 rgba(126, 201, 255, 0.28), inset 0 -1px 0 0 rgba(4, 90, 124, 0.52);*/
    border: 3px solid #045a7c;
    border-radius: 3px;
    font-weight: 300;
    font-size: 12px;

    .desc {
      font-weight: 300;
    }

    &.orange {
      border-color: #ff7d1c;
      background: #e26100;
    }

    &.yellow {
      border-color: #ffc300;
      background: #ea9e00;
    }

    &.purple {
      border-color: #961fbb;
      background-color: #7f1e9e;
    }

    &.green {
      border-color: #76be00;
      background: #448b00;
    }

    &.red {
      border-color: #d10000;
      background: #a8000b;
    }

    &.blue {
      border-color: #007bff;
      background-color: #0056b3;
    }

    &.dark-btn {
      background-color: #0b3d5b;
      border: 4px solid var(--background-color-secondary);
    }
  }
  &.inmate-movement-information {
    align-items: center;
    flex-grow: 1;
    gap: unset;

    .key,
    .value {
    }

    .key {
      height: 25px !important;
      text-transform: unset !important;
      font-weight: 300 !important;
      background-color: #045a7c;
    }

    .value {
      height: 32px !important;
      margin-right: 10px;

      &:last-child {
        margin-right: unset !important;
      }
    }
  }
`;

export const InmateInformation = styled(Col)`
  ${InmateInformationMixinCss}
`;

export const FlagSection = styled.section`
  margin-bottom: 10px;
  padding: 0 10px;
`;

export const FlagHeader = styled(FlagContainer)`
  width: 100%;
  justify-content: space-between;
  gap: 10px;
  padding: 0 10px;
  min-height: 45px;
  align-items: center;
  ${({ enabled }) =>
    !enabled && {
      background: `${CONSTANT.BUTTON_SECONDARY_BG} !important`,
      boxShadow: "unset !important",
    }}
`;

export const FlagBody = styled.div`
  margin: 10px 0 0px 10px;
  color: ${CONSTANT.BLACK};
  .date-range {
    display: flex;
    margin-bottom: 10px;
  }
`;

export const DateTypeContainer = styled(Row)`
  margin-bottom: 10px;
`;

export const FlagFooter = styled.div`
  display: flex;
  margin: 10px 0 0 10px;
  display: flex;
  gap: 10px;
  justify-content: flex-end;
`;

export const BookingsSectionTitle = styled.h6`
  position: relative;
  margin: 30px 0 15px 0;
  line-height: 20px;
  color: var(--text-black);
  font-weight: 600;
  text-transform: uppercase;

  & span {
    background-color: white;
    padding: 0 15px;
    margin-left: 20px;
    display: inline-block;
    position: relative;
    z-index: 1;
  }

  &:after {
    content: "";
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    /*right: 0;*/
    width: 100%;
    height: 2px;
    z-index: 0;
    background-color: rgba(0, 0, 0, 0.15);
  }
`;
